import React from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import useWorkspaceMembership from "../../models/workspace-membership/use-workspace-membership";
import {selectableWorkspaceMemberships} from "../../models/workspace-membership/workspace-membership-availability";
import {useTranslate} from "../../system/useTranslate";

export default function SelectWorkspaceDialog({visible, setVisible}) {
    const translate = useTranslate();
    const navigate = useNavigate();
    const membershipApi = useWorkspaceMembership();
    const memberships = useSelector((state) => state.app.workspaceMembershipsData);
    const select = async (membership) => {
        await membershipApi.updateDefaultWorkspaceMembership(membership.documentId || membership.id);
        setVisible(false);
    };
    return (
        <Dialog header={translate("select-workspace")} visible={visible} onHide={() => setVisible(false)} className="w-full md:w-30rem">
            <div className="flex flex-column gap-2">
                {selectableWorkspaceMemberships(memberships).map((membership) => <Button key={membership.documentId || membership.id} text className="justify-content-start" label={membership.workspace?.name} onClick={() => select(membership)}/>)}
                <Button outlined icon="pi pi-plus" label={translate("create-new-workspace")} onClick={() => {setVisible(false); navigate("/workspace/create");}}/>
            </div>
        </Dialog>
    );
}
